import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.tsx'

// Render first, then init third-party scripts (bundle-defer-third-party)
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)

// Defer Sentry and analytics initialization after hydration
// This improves Time to Interactive (TTI) by ~100-200ms
if (typeof window !== 'undefined') {
  requestIdleCallback(
    async () => {
      const [{ initSentry }, { initAnalytics }] = await Promise.all([
        import('./lib/sentry'),
        import('./lib/analytics'),
      ])
      initSentry()
      initAnalytics()
    },
    { timeout: 2000 }
  )
}
